import wixData from 'wix-data';
import { getSecFilingsXml } from 'backend/fetchData';
import { parseSecXml, convertSecItemDate, getXbrlLink } from 'public/secFilingsFunctions';
import { getEntryFileLink } from 'backend/fetchData';

var startPosition = 0;

function finishLoading() {
    $w("#resultsGroup").expand();
    $w('#preloader').collapse();
}

function startLoading() {
    $w("#loadMoreButton").hide();
    $w("#resultsGroup").collapse();
    $w('#preloader').expand();
}

function orderResultsByKey(key, order = 'asc') {
    return function (a, b) {
        const varA = a[key];
        const varB = b[key];
        let comparison = 0;

        if (varA > varB) {
            comparison = 1;
        } else if (varA < varB) {
            comparison = -1;
        }
        return ((order === 'desc') ? (comparison * -1) : comparison);
    };
}

function popuplateSecItemRepeater(repeaterData) {
    $w("#secFilingsRepeater").data = repeaterData;

}

$w.onReady(async function () {

    $w("#secFilingsRepeater").onItemReady(async ($item, itemData, index) => {
    
    // Hack to prevent the IP to be blocked by https://www.sec.gov/
    setTimeout(async function(){

        $item("#dateFiled").text = convertSecItemDate(itemData.dateFiled);
        $item("#description").text = itemData.description;
        $item("#filing").text = itemData.filing;

        const xbrlLink = getXbrlLink($item("#dateFiled").text);

        if (xbrlLink) {
            $item('#buttonXbrl').link = xbrlLink;
        } else {
            $item('#buttonXbrl').hide();
        }

		let entryAccessionNum = itemData.accessionNum.replace(/-/g, "");
        const isS13Gfiling = itemData.filing === 'SC 13G/A';
        $item("#buttonHtml").target = '_blank';

		// WARNING: Always use original site address for accessing http functions, like that: https://about.wixsite.com/investor-relations/_functions/ because https://investors.wix.com/_functions/ or relative url like /_functions/ will not work.
		//$item("#buttonHtml").link = `https://about.wixsite.com/investor-relations/_functions/secFilings/${entryAccessionNum}/${isS13Gfiling}`;
        
        const link = await getSecFilings(entryAccessionNum,isS13Gfiling);
        console.log(link);
        $item("#buttonHtml").link = link;

        }, 80);
    });

    function getFileExtension(file) {
    let fileName = file.name;
    let fileExtension = fileName.substr(fileName.length - 3);
    return fileExtension;
}

async function getSecFilings(p1, p2) {

    const accessionNum = p1;
    const isS13Gfiling = p2 === 'true';

    const secUrlPrefix = 'https://www.sec.gov/Archives/edgar/data/1576789/';

    let entryJSON = `${secUrlPrefix}${accessionNum}/index.json`;

    console.log(entryJSON);
    const directoryPayload = await getEntryFileLink(entryJSON)
    console.log(directoryPayload);
    const directoryData = JSON.parse(directoryPayload); //BUG //Unexpected token < in JSON at position 0
    const files = directoryData.directory.item;
    const filteredFiles = files.filter(file => getFileExtension(file) === 'htm' || getFileExtension(file) === 'tml');
    const elementNum = isS13Gfiling ? 1 : filteredFiles.length - 1;
    let fileName = filteredFiles[elementNum].name;
    let link = `${secUrlPrefix}${accessionNum}/${fileName}`;

    return link;

}

    async function paginateSecFilings(items = [], start = 0, limit = 100) {
        const chunkSize = 100;
        const xmlResult = await getSecFilingsXml(start, limit);
        const moreItems = parseSecXml(xmlResult, chunkSize)
        if (moreItems.length > 0) {
            items = [...new Set([...items, ...moreItems])] //merge & dedupe
            return paginateSecFilings(items,limit, limit + chunkSize)
        }
        return items;
    }

    async function getFilteredResults() {
        startLoading();
        const currentData = $w("#secFilingsRepeater").data;

        const itemsList = await paginateSecFilings(currentData);

        const categoriesFilter = $w('#secCategoriesFilter').value;
        const yearsFilter = $w('#secYearsFilter').value;
        let filteredItems;
        const allCategories = 'all-categories';
        const allYears = 'all-years';

        if (yearsFilter === allYears && categoriesFilter !== allCategories) { // If only years filter is empty
            filteredItems = itemsList.filter(item => (item.filing === $w('#secCategoriesFilter').value));
        } else if (yearsFilter !== allYears && categoriesFilter === allCategories) { // If only categories filter is empty
            filteredItems = itemsList.filter(item => (item.dateFiled.slice(0, 4) === $w('#secYearsFilter').value));
        } else if (yearsFilter === allYears && categoriesFilter === allCategories) { // If both categories and years filters are EMPTY
            $w("#loadMoreButton").show();
            filteredItems = itemsList;
        } else if (yearsFilter !== allYears && categoriesFilter !== allCategories) { // If both categories and years filters are NOT empty
            filteredItems = itemsList.filter(item => (item.filing === $w('#secCategoriesFilter').value && item.dateFiled.slice(0, 4) === $w('#secYearsFilter').value));
        }

        popuplateSecItemRepeater(filteredItems);

        if (filteredItems.length === 0) {
            $w("#filterNoResults").expand();
        } else {
            $w("#filterNoResults").collapse();
        }

        finishLoading();

    }

    /* SEC Filings */

    function populateSecItems(recentItem) {
        popuplateSecItemRepeater(JSON.parse(recentItem.xmlDump));
    }

    async function fetchSecFromDb(count) {
        let recentItem = await wixData.query('secCache')
            .find()
            .then((results) => {
                return results.items[0];
            })
            .catch((err) => {
                let errorMsg = err;
            });

        return populateSecItems(recentItem);
    }

    await getSecFilingsXml(startPosition, 10).then((xml) => {
            let repeaterData = parseSecXml(xml, 0);
            popuplateSecItemRepeater(repeaterData);

            $w('#secFilingsRepeater').expand();
        })
        .catch((err) => {
            let errorMsg = err;
            console.log('errorMsg', errorMsg);
            fetchSecFromDb(10);
        });

    /* SEC Filings Categories Filter */
    $w('#secCategoriesFilter').onChange((event, $w) => {
        getFilteredResults();
    });

    $w('#secYearsFilter').onChange((event, $w) => {
        getFilteredResults();
    });

    /* Quarterly Results */

    const repeaterItems = ['item1', 'item2', 'item3', 'item4', 'item5'];

    $w("#quarterlyResultsRepeater").onItemReady(($w, itemData, index) => {
        $w("#title").text = itemData.title;
        $w("#subtitle").text = itemData.subtitle;

        repeaterItems.forEach(item => {
            if (itemData.hasOwnProperty(item + 'Text')) {
                $w('#' + item + 'Text').link = itemData[item + 'Url'];
                $w('#' + item + 'Text').label = itemData[item + 'Text'];
                $w('#' + item + 'Text').show();
                $w('#' + item + 'Arrow').show();
            }
        });
    });

    await wixData.query('quarterlyResults')
        .find()
        .then((results) => {
            let years = [];
            Object.entries(results.items).forEach(item => {
                if (item[1].year) years.push(item[1].year);
            });
            let filteredYears = [...new Set(years)].sort(function (a, b) { return a - b }).reverse();
            let yearsDropdownOptions = [];
            filteredYears.forEach(item => {
                yearsDropdownOptions.push({ 'label': item, 'value': item });
            });

            $w("#yearSelect").options = yearsDropdownOptions;
            $w("#yearSelect").selectedIndex = 0;
        })
        .catch((err) => {
            let errorMsg = err;
        });

    await wixData.query("quarterlyResults")
        .limit(4)
        .eq('year', $w("#yearSelect").value)
        .descending('year')
        .find()
        .then((results) => {
            let items = results.items;
            items = items.sort(orderResultsByKey('itemsOrder', 'desc'));
            $w("#quarterlyResultsRepeater").data = items;

            $w('#quarterlyResultsRepeater').show();
        });

});

// SEC Filings load more button event handler
export function loadMoreButton_click(event, $w) {
    $w("#moreLoader").show();
	$w("#loadMoreButton").hide();
    startPosition = startPosition + 10;
    var currentData = $w("#secFilingsRepeater").data;

    getSecFilingsXml(startPosition, 10).then((xml) => {
        const newData = parseSecXml(xml, 0);
        const mergedData = [...new Set([...currentData, ...newData])] //merge & dedupe
        popuplateSecItemRepeater(mergedData);
    }).then(() => {
		$w("#moreLoader").hide();
		$w("#loadMoreButton").show()
    }).catch(()=> {
		$w("#moreLoader").hide();
		$w("#loadMoreButton").show();
	});
}

// Quarterly results year dropdown event handler
export function yearSelect_change(event, $w) {
    let year = event.target.value.toString();

    wixData.query('quarterlyResults')
        .eq('year', year)
        .limit(4)
        .find()
        .then((results) => {
            let items = results.items;
            items = items.sort(orderResultsByKey('itemsOrder', 'desc'));
            $w('#quarterlyResultsRepeater').data = results.items;
        })
        .catch((err) => {
            let errorMsg = err;
        });
}